import { Button, Card, Col, Row } from "antd";
import { FormInstance } from "antd/lib/form";
import React, { Fragment, RefObject } from "react";
import BaseForm from "../components/Form/BaseForm";
import { Attachment, FormFieldConfig } from "../helpers/shared-interfaces";
import ModalCreator from "./ModalCreator";

interface Props {
  attachments: Attachment[];
  createAttachment: (combinedInfo: string) => Promise<void>;
  reference: RefObject<FormInstance>;
  showForm: boolean;
  alignVertical?: boolean;
  handleRemove: (id: string) => Promise<void> | void;
}

interface State {
  isLoadingAttachments: boolean;
  toggleDeleteModal: boolean;
  attachmentIdToDelete: string;
}

export const UNASSIGN_ATTACHMENT_FROM_TRANSFER_REQUEST = `
  mutation unassignAttachmentFromTransferRequest($id: ID!) {
    unassignAttachmentFromTransferRequest(id: $id ){
      result
      errors {
        property
        description
      }
    }
  }
`;

export const UNASSIGN_ATTACHMENT_FROM_REDEMPTION_REQUEST = `
  mutation unassignAttachmentFromCompanyRedemptionRequest($id: ID!) {
    unassignAttachmentFromRedemptionRequest(id: $id ){
      result
      errors {
        property
        description
      }
    }
  }
`;

export function generateAttachmentFormFields(props: {
  createAttachment: (combinedInfo: string) => void;
}): FormFieldConfig[] {
  return [
    {
      id: "attachment",
      name: "attachmentUrl",
      required: true,
      inputType: "fileUpload",
      rule: "string",
      label: "Attachments",
      changeHandler: props.createAttachment,
      colConfig: {
        span: 18,
      },
    },
  ];
}
export default class AttachmentsSection extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isLoadingAttachments: false,
      toggleDeleteModal: false,
      attachmentIdToDelete: "",
    };
  }

  handleDeleteClick = (id: string): void => {
    this.setState({
      attachmentIdToDelete: id,
    });
    this.toggleDeleteModal();
  };

  toggleDeleteModal = (): void => {
    this.setState((state) => ({ toggleDeleteModal: !state.toggleDeleteModal }));
  };

  handleRemove = (): void => {
    const { attachmentIdToDelete } = this.state;
    this.props.handleRemove(attachmentIdToDelete);
    this.toggleDeleteModal();
  };

  render(): JSX.Element {
    const attachmentFields = generateAttachmentFormFields({
      createAttachment: this.props.createAttachment,
    });

    return (
      <Fragment>
        <div>
          <Row gutter={[8, 8]}>
            {this.props.attachments?.map(
              (attachment: Attachment, index: number) => {
                return (
                  <Col
                    span={this.props.alignVertical ? 24 : 8}
                    key={attachment?.id}
                    style={{
                      marginBottom: "18px",
                    }}
                  >
                    {this.state.toggleDeleteModal &&
                      ModalCreator({
                        showModal: this.state.toggleDeleteModal,
                        onOkay: this.handleRemove,
                        toggleModal: this.toggleDeleteModal,
                        inscription:
                          "Are you sure you want to delete this document?",
                      })}
                    <Card>
                      <p>{attachment?.name ?? index + 1}</p>
                      <a
                        href={attachment.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Attachment
                      </a>
                      <Button
                        type="link"
                        id="delete-attachment"
                        onClick={() => this.handleDeleteClick(attachment.id)}
                      >
                        Delete
                      </Button>
                    </Card>
                  </Col>
                );
              },
            )}
          </Row>
        </div>
        <div>
          {this.props.showForm && (
            <div
              className="view-opportunity-row create-interaction-row"
              style={{
                marginTop: 0,
              }}
            >
              <Col>
                <BaseForm
                  layout="vertical"
                  reference={this.props.reference}
                  fields={attachmentFields}
                  fieldsToHide={[]}
                ></BaseForm>
              </Col>
            </div>
          )}
        </div>

      </Fragment>
    );
  }
}
